import React from "react";
import { CalendarDetail } from "./calendarDetail";
class CalendarDetailParent extends React.Component {
    render() {
        return (
            <CalendarDetail {...this.props} />
        )
    }
}
export default CalendarDetailParent